/* eslint-disable
    func-names,
    max-len,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const factory = function (Model, $q, $timeout) {
  let Transaction;
  return (Transaction = (function () {
    Transaction = class Transaction extends Model {
      static initClass() {
        this.prototype.$resource = 'document';
        this.prototype.isSelected = false;
      }

      $init() {}
      $post() {}

      $getSuggestions() {
        return (
          (this.categorization != null ? this.categorization.suggestedLedgers : undefined) || []
        );
      }

      $hasSuggestions() {
        return this.$getSuggestions().length > 0;
      }

      $getNotes() {
        return (this.categorization != null ? this.categorization.clientResponse : undefined) || '';
      }

      $hasNotes() {
        return this.$getNotes().length;
      }

      $getSelection() {
        return this.categorization != null ? this.categorization.selectedLedgerName : undefined;
      }

      $getSelectedLedgerAccountId() {
        return this.categorization != null
          ? this.categorization.selectedLedgerAccountId
          : undefined;
      }

      $getSelectedLedgerName() {
        return this.categorization != null ? this.categorization.selectedLedgerName : undefined;
      }

      $hasSelection() {
        return this.$getSelection();
      }

      $hasResponse() {
        return this.$hasNotes() || this.$hasSelection();
      }

      $selectLedger(selectedLedgerAccountId) {
        return this.$editCategorization({ selectedLedgerAccountId });
      }

      $editNotes(clientResponse) {
        return this.$editCategorization({ clientResponse });
      }

      $editCategorization(data) {
        const defaults = { suggestedLedgers: [] };

        return this.$apiCall({
          method: 'PUT',
          url: `${this.$getUrl(this.id)}/resources/categorization`,
          data: Object.assign(defaults, this.categorization, data),
        }).then(res => this.$set(this.$serialize(res.data)));
      }

      $serialize(data) {
        return Object.assign({}, data, {
          documentDate: new Date(data.documentDate),
          createdAt: new Date(data.documentCreationDate),
        });
      }

      $setHasSegmentAllocations(hasSegmentAllocations) {
        this.$set({
          ...this.$data(),
          hasSegmentAllocations,
        });
      }

      $isMultiline() {
        return this.dataEntries.length > 2;
      }
    };
    Transaction.initClass();
    return Transaction;
  })());
};

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.transaction', moduleDeps)
  .factory('Transaction', factory);
